import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-page-content wiki-page" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]

import WikiPlayCta from '@/components/view/information/WikiPlayCta.vue';
import GameGuideLinks from '@/components/view/information/GameGuideLinks.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_LocaleLink = _resolveComponent("LocaleLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('wiki.title')), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('wiki.introduction')), 1),
    _createElementVNode("nav", {
      class: "wiki-sections",
      "aria-label": _ctx.$t('wiki.title')
    }, [
      _createVNode(_component_LocaleLink, { to: { name: 'rules' } }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("span", {
            class: "material-icons",
            "aria-hidden": "true"
          }, "auto_stories", -1)),
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('wiki.rules')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('rules.gameplayRules')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, { to: { name: 'roles' } }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("span", {
            class: "material-icons",
            "aria-hidden": "true"
          }, "person", -1)),
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('wiki.roles')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('wiki.rolesTitle')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, { to: { name: 'expansions' } }, {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createElementVNode("span", {
            class: "material-icons",
            "aria-hidden": "true"
          }, "castle", -1)),
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('wiki.addons')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('wiki.addonsTitle')), 1)
        ]),
        _: 1
      })
    ], 8, _hoisted_3),
    _createVNode(GameGuideLinks),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('wiki.setup')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", {
        innerHTML: _ctx.$t('wiki.playerAssignment')
      }, null, 8, _hoisted_4),
      _createElementVNode("li", {
        innerHTML: _ctx.$t('wiki.revealPhase')
      }, null, 8, _hoisted_5)
    ]),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('wiki.missionSelection')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", {
        innerHTML: _ctx.$t('wiki.leaderSelection')
      }, null, 8, _hoisted_6),
      _createElementVNode("li", {
        innerHTML: _ctx.$t('wiki.teamProposal')
      }, null, 8, _hoisted_7),
      _createElementVNode("li", {
        innerHTML: _ctx.$t('wiki.voteTeam')
      }, null, 8, _hoisted_8)
    ]),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('wiki.missionPhase')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", {
        innerHTML: _ctx.$t('wiki.missionOutcome')
      }, null, 8, _hoisted_9),
      _createElementVNode("li", {
        innerHTML: _ctx.$t('wiki.revealMissionResult')
      }, null, 8, _hoisted_10)
    ]),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('wiki.specialRolesInteractions')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", {
        innerHTML: _ctx.$t('wiki.usingSpecialAbilities')
      }, null, 8, _hoisted_11),
      _createElementVNode("li", {
        innerHTML: _ctx.$t('wiki.assassinationPhase')
      }, null, 8, _hoisted_12)
    ]),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('wiki.victoryConditions')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", {
        innerHTML: _ctx.$t('wiki.determineWinner')
      }, null, 8, _hoisted_13)
    ]),
    _createVNode(WikiPlayCta)
  ]))
}
}

})